import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    vectorSearchFactoids: 'Search memory',
    vectorSearchFactoidsReasoning: 'Searching memory',
    vectorSearchFactoidsOutput: 'Found {{count}} memories',
    vectorSearchFactoidsNoop: 'No memories found',
    vectorSearchFactoidsError: 'Error searching memory',
    listFactoids: 'List memories',
    listFactoidsReasoning: 'Listing memories',
    listFactoidsOutput: 'Listed {{count}} memories',
    listFactoidsNoop: 'No memories found',
    listFactoidsError: 'Error listing memories',
  });
}
